import AttributeCard from "../AttributeCard/AttributeCard";
import { KPICardProps } from "./KPICard.types";
import clsx from "clsx";

const KPICard = ({ kpi, value, className, ...rest }: KPICardProps): JSX.Element => {
    return <AttributeCard className={clsx("kpi-card", className)} attribute={kpi} value={value} {...rest} />;
};

export default KPICard;
